import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { toast } from "react-toast";
import { updateRequests } from "./common/apiCalls";
import { logEventToAnalyticsPlatform } from "../../helper/events";
import { EVENTS } from "./events_constant";
import { ATTENDED, OFFLINE_CONSULTS } from "./common/constants";

export default function BulkActionsDialog({
  action,
  actionHeader,
  bulkActionDialogVisible,
  setBulkActionDialogVisibility,
  requestIds,
  fetchData,
  setFetchData,
  setSelectedIds,
  service
}) {
  const [remark, setRemark] = useState("");

  const updateAllRequests = async () => {
    try {
      setBulkActionDialogVisibility(false);
      let response = await updateRequests(service, requestIds, remark, action);
      if (response?.success) {
        setFetchData(!fetchData);
        setSelectedIds([]);
        toast.success("Request updated successfully");
        logEventToAnalyticsPlatform({
          name: EVENTS.PC_LS_ACTION.name,
          payload: {
            tab_name: EVENTS.TAB_NAME_UPCOMING_APPOINTMENTS,
            filterValue: 'true',
            reference_id: '',
            reference_provider_id: '',
            service_name: service?.includes(OFFLINE_CONSULTS) ? EVENTS.SERVICE_NAME_OFFLINE_CONSULTS: EVENTS.SERVICE_NAME_LABS,
            action: action === ATTENDED ? EVENTS.ACTION.BULK_ATTENDANCE_CLICKED : EVENTS.ACTION.BULK_CONFIRM_CLICKED,
          },
          schema: EVENTS.PC_LS_ACTION.schema,
        })

      } else {
        setSelectedIds([]);
        toast.error(`Request update failed - ${response?.error}`);
      }
    } catch (err) {
      setSelectedIds([]);
      toast.error(`Request update failed - ${err?.response?.data?.error}`);
    }
  };

  return (
    <Dialog open={bulkActionDialogVisible} onClose={() => setBulkActionDialogVisibility(false)} fullWidth={true} maxWidth={"sm"}>
      <DialogTitle style={{ background: "rgb(245 245 245)" }}>
        <div className="flex justify-between">
          <div className="font-semibold">
            <span className="cursor-pointer">{actionHeader}</span>
          </div>
          <div className="text-gray-500" onClick={() => setBulkActionDialogVisibility(false)}>
            <span className="cursor-pointer">
              <CloseIcon></CloseIcon>
            </span>
          </div>
        </div>
      </DialogTitle>
      <DialogContent>
        <Box className="mt-5">
          <div className="pb-10">
            <FormControl className="w-full">
              <TextField
                sx={{ fontSize: 14 }}
                id="remarks"
                label="Remarks"
                multiline
                name="remarks"
                onChange={(event) => setRemark(event.target.value)}
                rows={4}
                value={remark}
                required
              />
            </FormControl>
          </div>

          <div className="pb-5 flex justify-between text-center">
            <div
              className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold"
              type="submit"
              variant="contained"
              size="large"
              onClick={() => setBulkActionDialogVisibility(false)}
            >
              <span>Cancel</span>
            </div>
            <button
              className={
                remark === ""
                  ? "border-gray-500 bg-gray-500 text-gray-100 border cursor-default rounded-md w-40 p-1 text-sm font-semibold"
                  : "border-green-600 bg-green-600 text-gray-100 border cursor-pointer rounded-md w-40 p-1 text-sm font-semibold"
              }
              type="submit"
              variant="contained"
              size="large"
              disabled={remark === ""}
              onClick={() => updateAllRequests()}
            >
              <span>{actionHeader}</span>
            </button>
          </div>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
